module.exports = __webpack_public_path__ + "static/assets/7196ea839760d5449bd7067be8d4bd0d.svg";